// import axios from "axios";
import Properties from "../properties"
import apiClient from "../plugins/axios-instance";

const API_URL = "https://pelanggan." + Properties.DOMAIN_URL + "/api/v1";
// const API_URL = "http://localhost:8000/api";

export default class PromoAPIService {
    constructor() {}
    static getAllPromo = (limit, page, body) =>
        apiClient.get(API_URL + "/promos/limit/" + limit + "?page=" + page, {
            params: body,
        });
    static getListPromo = (body) =>
        apiClient.get(API_URL + "/promos/list", {
            params: body,
        });
    static getActivePromo = (limit, page) => {
        return apiClient.get(API_URL + "/promos/limit/" + limit + "?page=" + page, {
            params: {
                onPeriode: "true",
                status: "A",
            },
        });
    };
    static getActivePromoKhusus = (limit, page) => {
        return apiClient.get(API_URL + "/promos/limit/" + limit + "?page=" + page, {
            params: {
                onPeriode: "true",
                khusus: "0",
                status: "A",
            },
        });
    };
    static editPromo = (kode, promo) =>
        apiClient.post(API_URL + "/promos/" + kode, promo, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    static createPromo = (promo) =>
        apiClient.post(API_URL + "/promos", promo, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    static deletePromo = (nik, kode) =>
        apiClient.delete(API_URL + "/promos/" + kode, {
            params: {
                user_update: nik,
            },
        });

    static tukarPromo = (body) =>
        apiClient.post(API_URL + "/tukar-promos", body, {
        });

    static getTukarPromo = (kodePromo, kodeCust, limit) =>
        apiClient.get(
            API_URL +
            "/tukar-promos/" +
            kodePromo +
            "/kode-member/" +
            kodeCust +
            "/limit/" +
            limit, {
            }
        );

    static getTukarPromoVoucher = (voucher, limit, body) => {
        return apiClient.get(
            API_URL +
            "/tukar-promos" +
            "/kode-voucher/" +
            voucher +
            "/limit/" +
            limit, {
                params: body,
            }
        );
    }

    static getPromo = (kode) =>
        apiClient.get(API_URL + "/promos/" + kode, {
        });
}
